<script>
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import Button from '@/components/Button'
import PincodeInput from '@/components/PincodeInput'
import AccountServices from '@/services/accounts'
import EnvironmentUtils from '@/utils/environmentUtils'
import DeviceUtils from '@/utils/deviceUtils'
import IdentifyUtils from '@/utils/identifyUtils'
import StringUtils from '@/utils/stringUtils'
import UsersServices from '@/services/users'

const REF_LOGIN_STEP_IDENTIFIER = 'login-step-identifier'
const REF_LOGIN_STEP_LOST_PASSWORD = 'login-step-lost-password'
const REF_LOGIN_STEP_LOST_PASSWORD_TOKEN = 'login-step-lost-password-token'
const REF_LOGIN_STEP_RESET_PASSWORD = 'login-step-reset-password'
const REF_LOGIN_STEP_RESET_PASSWORD_SUCCESS = 'login-step-reset-password-success'
const REF_LOGIN_STEP_PASSWORD = 'login-step-password'
const REF_LOGIN_STEP_LOGGED = 'login-step-logged'
const REF_IDENTIFIER_INPUT = 'ref-identifier-input'
const REF_PASSWORD_INPUT = 'ref-password-input'
const REF_VISUALS_IDENTIFIER = 'login-visuals-identifier'
const REF_VISUALS_PASSWORD = 'login-visuals-password'

export default
{
    name: 'login-form',

    props:
    {
        onSuccessful: { type: Function }
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div id='login-form'>

                {/* Identifier providing step */}
                <div ref={REF_LOGIN_STEP_IDENTIFIER}>
                    <div ref={REF_VISUALS_IDENTIFIER} class='login-visuals'>
                        <inline-svg src={require('@/assets/img/key-kawaii.svg')} class='icon animated' />
                        <p class='login-slogan'>Se connecter à mon compte</p>
                    </div>

                    <FloatingLabelTextInput ref={REF_IDENTIFIER_INPUT} type='email' placeholder='Pseudo ou courriel' icon={require('@/assets/img/user-outlined.svg')}
                        on-focus={this.onInputFocus} on-blur={this.onInputBlur} on-enter={this.onInputEnter} v-model={this.identifier} />

                    <Button class='button-next' is-loading={this.buttonNextLoading} text='Suivant' on-click={this.onButtonNextClicked} />
                    <Button class='lost-password-btn' text="J'ai oublié mon mot de passe" on-click={this.onLostPasswordButtonClicked} type='text' />
                </div>

                {/* Password providing step */}
                <div ref={REF_LOGIN_STEP_PASSWORD}>
                    <div ref={REF_VISUALS_PASSWORD} class='login-visuals'>
                        <inline-svg src={require('@/assets/img/smile.svg')} class='icon' />
                        <p class='login-slogan'>Content de vous revoir, <strong>{ this.user.firstName }</strong></p>
                    </div>

                    <FloatingLabelTextInput ref={REF_PASSWORD_INPUT} type='password' placeholder='Votre mot de passe' icon={require('@/assets/img/key-outlined.svg')}
                        on-focus={this.onInputFocus} on-blur={this.onInputBlur} on-enter={this.onInputEnter} />

                    <Button class='button-next' is-loading={this.buttonNextLoading} text="M'identifier" on-click={this.onButtonNextClicked} />
                    <Button class='lost-password-btn' text="J'ai oublié mon mot de passe" on-click={this.onLostPasswordButtonClicked} type='text' />
                </div>

                {/* Lost password step */}
                <div ref={REF_LOGIN_STEP_LOST_PASSWORD}>
                    <div class='login-visuals'>
                        <inline-svg src={require('@/assets/img/boy-thinking.svg')} class='icon animated' />
                        <p class='login-slogan'>Mot de passe oublié</p>
                    </div>

                    <FloatingLabelTextInput type='email' placeholder='Pseudo ou courriel' icon={require('@/assets/img/user-outlined.svg')} ref='lostPasswordIdentifierField'
                        on-focus={this.onInputFocus} on-blur={this.onInputBlur} on-enter={this.onInputEnter} v-model={this.identifier} />

                    <Button class='button-next' is-loading={this.buttonNextLoading} text='Suivant' on-click={this.onButtonNextClicked} />
                </div>

                {/* Lost password token step */}
                <div ref={REF_LOGIN_STEP_LOST_PASSWORD_TOKEN}>
                    <div class='login-visuals'>
                        <inline-svg src={require('@/assets/img/padlock.svg')} class='icon animated' />
                        <p class='login-slogan'>Entrez le code que vous avez reçu par courriel</p>
                    </div>

                    <pincode-input length={6} uppercase-only={true} allow-alphabeticals={true} allow-numerals={false} v-model={this.passwordResetToken}
                        ref='passwordResetPinInput' on-pin-complete={this.onButtonNextClicked} />

                    <Button class='button-next' is-loading={this.buttonNextLoading} text='Suivant' on-click={this.onButtonNextClicked}
                        disabled={StringUtils.isEmptyString(this.passwordResetToken)} />
                </div>

                {/* Reset password step */}
                <div ref={REF_LOGIN_STEP_RESET_PASSWORD}>
                    <div class='login-visuals'>
                        <inline-svg src={require('@/assets/img/shield.svg')} class='icon animated' />
                        <p class='login-slogan'>Choisissez un nouveau mot de passe</p>
                    </div>

                    <FloatingLabelTextInput type='password' placeholder='Nouveau mot de passe' icon={require('@/assets/img/key-outlined.svg')}
                        on-focus={this.onInputFocus} on-blur={this.onInputBlur} on-enter={this.onInputEnter} v-model={this.newPassword} />
                    
                    <Button class='button-next' is-loading={this.buttonNextLoading} text='Suivant' on-click={this.onButtonNextClicked}
                        disabled={StringUtils.isEmptyString(this.newPassword)} />
                </div>

                {/* Reset password success step */}
                <div ref={REF_LOGIN_STEP_RESET_PASSWORD_SUCCESS}>
                    <div class='login-visuals'>
                        <inline-svg src={require('@/assets/img/check.svg')} class='icon animated' />
                        <p class='login-slogan'>Votre mot de passe a été réinitialisé !</p>
                    </div>

                    <Button class='button-next' is-loading={this.buttonNextLoading} text='Se connecter' on-click={this.onButtonNextClicked} />
                </div>

                {/* Identification success step */}
                <div ref={REF_LOGIN_STEP_LOGGED}>
                    <div class='login-visuals'>
                        <inline-svg src={require('@/assets/img/checked.svg')} class='icon' />
                        <p class='login-slogan'>Vous êtes maintenant identifié{this.user.isFemale ? 'e' : ''}</p>
                    </div>

                    <Button has-shadow={true} class='button-next' text="Retourner à l'accueil" on-click={this.onButtonNextClicked} />                    
                </div>
            </div>
        )
    },

    mounted ()
    {
        this.loginStep = 'identifier'
    },

    data () 
    {
        return {
            loginStep: '',
            identifier: '',
            passwordResetToken: '',
            newPassword: '',
            buttonNextLoading: false,
            user: {}
        }
    },

    watch:
    {
        loginStep (newVal, oldVal)
        {
            this.loginStepIdentifierContainer.style.display = 'none'
            this.loginStepPasswordContainer.style.display = 'none'
            this.loginStepLostPasswordContainer.style.display = 'none'
            this.loginStepLostPasswordTokenContainer.style.display = 'none'
            this.loginStepResetPasswordContainer.style.display = 'none'
            this.loginStepResetPasswordSuccessContainer.style.display = 'none'
            this.loginStepLoggedContainer.style.display = 'none'

            let toShow
            if (newVal == 'identifier')
            {
                toShow = this.loginStepIdentifierContainer
            }
            else if (newVal == 'password')
            {
                toShow = this.loginStepPasswordContainer
            }
            else if (newVal == 'lost-password')
            {
                toShow = this.loginStepLostPasswordContainer
            }
            else if (newVal == 'lost-password-token')
            {
                toShow = this.loginStepLostPasswordTokenContainer
            }
            else if (newVal == 'reset-password')
            {
                toShow = this.loginStepResetPasswordContainer
            }
            else if (newVal == 'reset-password-success')
            {
                toShow = this.loginStepResetPasswordSuccessContainer
            }
            else if (newVal == 'logged')
            {
                toShow = this.loginStepLoggedContainer
            }
            else
            {
                throw new Error(`Unknown login step: '${newVal}'`)
            }

            toShow.style.display = 'inherit'
        }
    },

    computed:
    {
        loginStepIdentifierContainer ()
        {
            return this.$refs[REF_LOGIN_STEP_IDENTIFIER]
        },

        loginStepPasswordContainer ()
        {
            return this.$refs[REF_LOGIN_STEP_PASSWORD]
        },

        loginStepLostPasswordContainer ()
        {
            return this.$refs[REF_LOGIN_STEP_LOST_PASSWORD]
        },

        loginStepLostPasswordTokenContainer ()
        {
            return this.$refs[REF_LOGIN_STEP_LOST_PASSWORD_TOKEN]
        },

        loginStepResetPasswordContainer ()
        {
            return this.$refs[REF_LOGIN_STEP_RESET_PASSWORD]
        },

        loginStepResetPasswordSuccessContainer ()
        {
            return this.$refs[REF_LOGIN_STEP_RESET_PASSWORD_SUCCESS]
        },

        loginStepLoggedContainer ()
        {
            return this.$refs[REF_LOGIN_STEP_LOGGED]
        },

        visualsIdentifier ()
        {
            return this.$refs[REF_VISUALS_IDENTIFIER]
        },

        visualsPassword ()
        {
            return this.$refs[REF_VISUALS_PASSWORD]
        },

        identifierInput ()
        {
            return this.$refs[REF_IDENTIFIER_INPUT]
        },

        passwordInput ()
        {
            return this.$refs[REF_PASSWORD_INPUT]
        }
    },

    methods:
    {
        onInputFocus ()
        {
            if (cordova.platformId == 'android')
            {
                this.hideVisuals()
            }
        },

        onInputBlur ()
        {
            if (cordova.platformId == 'android')
            {
                this.showVisuals()
            }
        },

        hideVisuals ()
        {
            let visuals
            let input
            if (this.loginStep == 'identifier')
            {
                visuals = this.visualsIdentifier
                input = this.identifierInput
            }
            else
            {
                visuals = this.visualsPassword
                input = this.passwordInput
            }

            visuals.style.transition = 'all 0.5s cubic-bezier(0, 1, 0, 1)'
            visuals.style.maxHeight = 0
            visuals.style.opacity = 0

            input.hideHintMessage()
        },

        showVisuals ()
        {
            let visuals
            if (this.loginStep == 'identifier')
            {
                visuals = this.visualsIdentifier
            }
            else
            {
                visuals = this.visualsPassword
            }

            visuals.style.transition = 'all  0.4s ease-in-out'
            visuals.style.maxHeight = '100vh'
            visuals.style.opacity = 1
        },

        onInputEnter ()
        {
            this.identifierInput.blur()
            this.onButtonNextClicked()
        },

        async onButtonNextClicked ()
        {
            if (this.buttonNextLoading) return
            this.buttonNextLoading = true

            if (this.loginStep == 'identifier')
            {
                const success = await this.proceedIdentifierStep()
                if (success) this.loginStep = 'password'
            }
            else if (this.loginStep == 'password')
            {
                const success = await this.proceedPasswordStep()
                if (success) this.loginStep = 'logged'
            }
            else if (this.loginStep == 'lost-password')
            {
                const success = await this.proceedLostPasswordStep()
                if (success) this.loginStep = 'lost-password-token'
            }
            else if (this.loginStep == 'lost-password-token')
            {
                const success = await this.proceedLostPasswordTokenStep()
                if (success) this.loginStep = 'reset-password'
            }
            else if (this.loginStep == 'reset-password')
            {
                const success = await this.proceedResetPasswordStep()
                if (success) this.loginStep = 'reset-password-success'
            }
            else if (this.loginStep == 'reset-password-success')
            {
                this.loginStep = 'password'
            }
            else if (this.loginStep == 'logged')
            {
                this.$router.push('/home')
            }
            else
            {
                console.error(`Unknown login step: '${this.loginStep}'`)
            }

            this.buttonNextLoading = false
        },

        async onLostPasswordButtonClicked ()
        {
            this.loginStep = 'lost-password'
        },

        async proceedIdentifierStep ()
        {
            const identifier = this.identifierInput.inputText
            this.$ga.event('login', 'identifier', identifier)

            try
            {
                const response = await AccountServices.searchAccount(identifier, EnvironmentUtils.cityId)
                this.user = response
            }
            catch (e)
            {
                var message = ''
                if (e.message.includes('404')) message = 'Aucun compte n\'est lié à cet identifiant'
                else message = 'Impossible de se connecter avec cet identifiant'

                this.identifierInput.setErrorMessage(message)

                console.error(e)

                return false
            }

            return true
        },

        async proceedPasswordStep ()
        {
            const identifier = this.user.username
            this.$ga.event('login', 'password', identifier)

            const cityId = EnvironmentUtils.cityId
            try
            {
                const loginResponse = await AccountServices.login(identifier, this.passwordInput.inputText, cityId, DeviceUtils.deviceInfo)
                const token = loginResponse.token
                await this.$store.dispatch('user/fetchUserInformationFromToken', { token, cityId })
            }
            catch (e)
            {
                this.passwordInput.setErrorMessage('Ce mot de passe est erroné.')

                console.error(e)

                return false
            }

            // some tags default values differ weather user is admin or not.
            UsersServices.getUser(EnvironmentUtils.cityId, this.$store.state.user.token)
            IdentifyUtils.identify({ username: identifier, email: identifier.includes('@') ? identifier : undefined })
            
            this.$router.push('/settings')

            if (this.onSuccessful) this.onSuccessful()

            return true
        },

        async proceedLostPasswordStep ()
        {
            try
            {
                this.user = await AccountServices.searchAccount(this.identifier, EnvironmentUtils.cityId)
                await AccountServices.recoverPassword(this.user.id)
            }
            catch (e)
            {
                this.$refs.lostPasswordIdentifierField.setErrorMessage('Aucun compte n\'est lié à cet identifiant')

                console.error(e)

                return false
            }

            return true
        },

        async proceedLostPasswordTokenStep ()
        {
            try
            {
                await AccountServices.getPasswordRecoveryToken(this.user.id, this.passwordResetToken)
            }
            catch (e)
            {
                this.$refs.passwordResetPinInput.setErrorMessage('Ce code est erroné')

                console.error(e)

                return false
            }

            return true
        },

        async proceedResetPasswordStep ()
        {
            try
            {
                await AccountServices.usePasswordRecoveryToken(this.user.id, this.passwordResetToken, this.newPassword)
            }
            catch (e)
            {
                console.error(e)

                return false
            }

            return true
        }
    },

    components:
    {
        FloatingLabelTextInput,
        Button,
        PincodeInput
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#login-form
{
    padding-top: 6vh;
    padding-bottom: 6vh;

    .OnTablet({
        padding-left: 6vw;
        padding-right: 6vw;
    });

    .OnDesktop({
        padding-top: 10vh;
        padding-bottom: 10vh;
        padding-left: 8vw;
        padding-right: 8vw;
    });

    .floating-label-text-input
    {
        height: 14vw;
        font-size: 5vw;

        .OnTablet({
            height: 8vw;
            font-size: 3vw;
        });

        .OnDesktop({
            height: 6vh;
            font-size: 2vh;
        });
    }

    .login-visuals
    {
        pointer-events: none;
        transition-delay: 0ms;
        max-height: 100vh;
        opacity: 1;

        .icon
        {
            height: auto;
            margin-bottom: 4vh;
            fill: var(--theme-accent-color);

            width: 40%;
            margin-left: 30%;

            .OnTablet({
                width: 35%;
                margin-left: 32.5%;
            });

            .OnDesktop({
                width: 30%;
                margin-left: 35%;
            });
        }

        .login-slogan
        {
            font-family: Nunito;
            color: var(--theme-text-color-light);
            text-align: center;
            font-weight: bold;
            margin-bottom: 6vh;
            font-size: 25px;

            .OnTablet({ font-size: 4vw; });
            .OnDesktop({ font-size: 2vw; });
            .OnLarge({ font-size: 1.5vw; });

            .pincode-input
            {
                color: var(--theme-text-color-dark);
            }
        }
    }

    .button-next
    {
        width: 100%;
        margin-top: 2.5vh;
    }

    .lost-password-btn
    {
        margin: 20px auto;
        margin-bottom: 0;
        font-size: 90%;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/LoginForm.vue